import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { LoadingService } from './loading.service';
import { State } from '../models/domain/State';
import { PagedResponse } from '../models/general/PagedResponse';

@Injectable({
  providedIn: 'root'
})
export class StateService extends BaseService<State> {
  private readonly rowCountSubject: BehaviorSubject<number>;
  public readonly rowCount$: Observable<number>;
  private http: HttpClient;

  constructor(http: HttpClient, loadingService: LoadingService) {
    super(http, `${environment.apiUrl}/v1/state`, loadingService);
    this.http = http;
    this.rowCountSubject = new BehaviorSubject<number>(0);
    this.rowCount$ = this.rowCountSubject.asObservable();
  }

  public getStateByCountry(countryId: number): Observable<HttpResponse<PagedResponse<State>>> {
    return this.httpClient.get<PagedResponse<State>>(`${this.baseApiUrl}/${countryId}/states`, { observe: "response" })
      .pipe(
        catchError(error => {
          return throwError(() => error); // Make sure to throw the error properly
        }),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      );
  }
}